import { createContext, type ReactNode, useContext, useState } from 'react';
import { useBangKeHoaDonMuaHangExport } from './hooks';

interface BangKeHoaDonMuaHangContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
  queryParams: MuaHangRecord | null;
  setQueryParams: (params: MuaHangRecord | null) => void;
}

const BangKeHoaDonMuaHangContext = createContext<BangKeHoaDonMuaHangContextValue | null>(null);

export const useBangKeHoaDonMuaHangContext = () => {
  const context = useContext(BangKeHoaDonMuaHangContext);
  if (!context) {
    throw new Error('useBangKeHoaDonMuaHangContext must be used within BangKeHoaDonMuaHangProvider');
  }
  return context;
};

export const BangKeHoaDonMuaHangProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<MuaHangRecord | null>(null);
  const { exportToExcel, canExport, isExporting } = useBangKeHoaDonMuaHangExport(queryParams);

  return (
    <BangKeHoaDonMuaHangContext.Provider value={{ exportToExcel, canExport, isExporting, queryParams, setQueryParams }}>
      {children}
    </BangKeHoaDonMuaHangContext.Provider>
  );
};
